// ad-icon-grid — forum_list_icon 广告位(5×4 格,最多 20 条)。
// 内部 useAdFeed → computeVisible → 渲染 20 个坑位(有广告 <img>,空位 <AdPlaceholder variant="icon">)。
// 每格图标+文字竖排;对应 .pen 节点 J2JB4h(5×4)。
import { useState, useEffect } from 'react'
import { AD_CAP } from '../../_lib/ad-slot'
import type { Ad } from '../../_lib/ad-rotate'
import { computeVisible } from '../../_lib/ad-rotate'
import { useAdFeed } from '../../_lib/ad-api'
import { getForumIdentity } from '../../_lib/forum-device-id'
import { trackAndOpen } from './track-click'
import { AdPlaceholder } from './ad-placeholder'

const SLOT = 'forum_list_icon'
const CAP = AD_CAP[SLOT]

export function AdIconGrid() {
  const { data } = useAdFeed(SLOT)
  const [visible, setVisible] = useState<Ad[]>([])

  useEffect(() => {
    if (!data) return
    const identity = getForumIdentity()
    computeVisible(data.ads, data.order_mode, identity, CAP)
      .then(setVisible)
      .catch(() => setVisible([]))
  }, [data])

  // .pen J2JB4h:无外框;5×4 网格,横竖间距 7,左右 slot 与上下内容元素左右对齐(由父 px-3 提供)。
  // 每格 = 方形 slot(圆角14) + 下方标签(gap 6)。grid-cols-5 gap-[7px] 自动等分,slot 用
  // aspect-square 撑满格宽(402 视口 / px-3 下正好 70px),与设计一致。
  return (
    <div className="grid grid-cols-5 gap-[7px]">
      {Array.from({ length: CAP }, (_, i) => {
        const pos = i + 1
        const ad = visible[i]
        if (ad) {
          return (
            <button
              key={ad.id}
              type="button"
              data-testid={`ad-icon-${pos}`}
              className="flex w-full flex-col items-center gap-1.5"
              onClick={() => trackAndOpen(ad.id, SLOT, pos, ad.target_url)}
            >
              <img
                src={ad.image_url}
                alt="广告"
                className="aspect-square w-full rounded-[14px] bg-white object-contain"
              />
              {ad.slogan && (
                <span className="w-full truncate text-center text-[11px] font-medium leading-tight text-ink">
                  {ad.slogan}
                </span>
              )}
            </button>
          )
        }
        return (
          <div key={`placeholder-${pos}`} data-testid={`ad-icon-${pos}`}>
            <AdPlaceholder variant="icon" />
          </div>
        )
      })}
    </div>
  )
}
